/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';

import ColumnFilterSort from '../../../components/tableServerSide/ColumnFilterSort';

export const columnSortModifiersLinkedAccounts = {
  number: null,
  name: null,
  defaultSort: { name: 'asc' }
};

export const columnFilterModifiersLinkedAccounts = {
  name: { expression: 'Like' }
};

export const getLinkedAccountsColumns = () => {
  return [
    {
      Header: tableInstance => <ColumnFilterSort header='Account Number' tableInstance={tableInstance} align='right' />,
      accessor: 'number',
      width: 200,
      Cell: ({ value, row }) => (
        <Link to={`/accounts/departments/${row.original.id}`} style={{ color: '#3498db', textDecoration: 'underline' }}>
          {value}
        </Link>
      )
    },
    {
      Header: tableInstance => <ColumnFilterSort header='Account Name' tableInstance={tableInstance} />,
      accessor: 'name',
      width: 650
    }
  ];
};
